import { Component, h, State, Prop} from '@stencil/core';
import spinner from '@se/icons/svg/spinner.svg';
import pdfIcon from './assets/pdfIcon.svg';
import { downloadFileBlob } from '../utils';
import type { QuotePdfConfiguration } from '../SearchTableConfiguration';
import axios from 'axios';
import { makeLogger } from '../../../../../logger/logger';

const { err } = makeLogger({
  pathToCurrentFile: 'components/result-page/search-tab/tabular/subcomponents/quotes-pdf.tsx',
  loggersList: ['err']
});

@Component({
  tag: 'uiaas-search-quotes-list-pdf'
})
export class QuotesPdf {
  @State() isLoading = false;
  @State() showPdfButton = false;
  @Prop() readonly pdfConfiguration: QuotePdfConfiguration;
  @Prop() readonly quoteNumber: string;

  private getRequestConfiguration() : RequestInit{
      const myHeaders = new Headers();
      myHeaders.append('x-api-key', `${this.pdfConfiguration.apiKey}`);
      myHeaders.append('x-idms-authorization', `${this.pdfConfiguration.token}`);
      const requestOptions: RequestInit = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      return requestOptions;
  }

  private getRequestHeaders(): any{//eslint-disable-line @typescript-eslint/no-explicit-any
      return {
        'x-api-key': `${this.pdfConfiguration.apiKey}`,
        'x-idms-authorization': `${this.pdfConfiguration.token}`
      };
  }

  private getPdf(){
      const host = encodeURI(`${this.pdfConfiguration.url}`);
      const url = new URL(`${host}/utility/pdf-location/MySEDE/QuotationStatus`);

      axios.get(url.toString(), {
        headers: this.getRequestHeaders()
      })
        .then(async (response) => {
            if (response.status != 200) {
              throw new Error(`HTTP error: ${response.status}`);
            }
            if(response.data.pdfInRemoteStorage){
              await this.getPdfUrl();
            }else{
              downloadFileBlob(response.data, `Quotations_${this.quoteNumber}`);
            }
        })
        .catch(function (error) {
            err(error);
        });
  }

  private async getPdfUrl() {
      const quoteNumber = encodeURI(`${this.quoteNumber}`);
      const host = encodeURI(`${this.pdfConfiguration.url}`);
      const url = `${host}/system/myse-quotation/quotations/MySEDE/${quoteNumber}/pdf`;
      const pdfUrl = new URL(url);
      pdfUrl.searchParams.append('countryCode', this.pdfConfiguration.countryCode);
      pdfUrl.searchParams.append('country-code', this.pdfConfiguration.countryCode);
      pdfUrl.searchParams.append('languageCode', this.pdfConfiguration.language);
      pdfUrl.searchParams.append('language-code', this.pdfConfiguration.language);
      pdfUrl.searchParams.append('purchaserId', this.pdfConfiguration.purchaserId);
      pdfUrl.searchParams.append('purchaser-id', this.pdfConfiguration.purchaserId);

      axios.get(pdfUrl.toString(), {
        headers: this.getRequestHeaders()
      })
        .then(async (response) => {
            if (response.status != 200) {
              throw new Error(`HTTP error: ${response.status}`);
            }

            await this.getFileFromS3(response.data.pdfRemoteStorageURL);
        })
        .catch(function (error) {
            err(error);
        });
  }

  private async getFileFromS3(url: string){
      const fileName = `Quotations_${this.quoteNumber}`;
      await axios.get(url, {
        headers: this.getRequestHeaders(),
        responseType: 'blob'
      })
        .then(response => {
            if (response.status != 200) {
              throw new Error(`HTTP error: ${response.status}`);
            }
            downloadFileBlob(response.data, fileName);
        })
        .catch(function (error) {
            err(error);
        });
  }

  componentWillLoad() {
      this.isLoading = true;
      axios.get(`${this.pdfConfiguration.url}/system/myse-quotation/quotation-pdf-availability/MySEDE/${this.quoteNumber}?purchaserId=${this.pdfConfiguration.purchaserId}&purchaser-id=${this.pdfConfiguration.purchaserId}`,
        {
          headers: this.getRequestHeaders()
        }).then(response => {
          if (response.status != 200) {
            throw new Error(`HTTP error: ${response.status}`);
          }
          if(response.data.pdfAvailability){
            this.showPdfButton = true;
          }
      }).catch(function (error) {
          err(error);
      }).finally(() => {
          this.isLoading = false;
      });
  }

  render(){
      return <div>
        <div class="loading__container">
          {this.isLoading ? (
            <div
              class="loading-icon"
              innerHTML={spinner}
            ></div>) : (
            this.showPdfButton ? <button class="search-table-link-file search-table-pdf-buttton" innerHTML={pdfIcon} onClick={() =>this.getPdf()}/> : ''
          )}
        </div>
      </div>;
  }
}
